import { Observable, EMPTY as EMPTY_OBSERVABLE } from 'rxjs'
import { TOKENS_CAN_BE_COMPLETED } from '@aytm/app/stats/lib/draft-js/autocompletePlugin/lib/tokens'
import processSuggestionData from '@aytm/app/stats/lib/draft-js/autocompletePlugin/lib/process-suggestion-data'

const codebookTokenType = 'STR'

export default function createCodebookSuggestion(
  _,
  __,
  {
    dependencies: {
      aytmLogic: { refsList, codebooks },
      parserResult
    }
  }
) {
  if (!codebooks || !parserResult || !refsList) {
    return EMPTY_OBSERVABLE
  }

  const {
    tokens: { expected, type },
    text: { nonParsed }
  } = parserResult

  if (
    expected.last &&
    expected.last.includes(codebookTokenType) &&
    ['EQ', 'IN'].includes(type.last) &&
    ('CODEBOOK' == type.prelast || ('BREF' == type.prelast && 'CODEBOOK' == type.preprelast))
  ) {
    const transformToSuggestion =
      ({ canBeCompleted, parserResult }) =>
      codebook => {
        const token = codebookTokenType
        const label = '"' + codebook.title.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&') + '"'

        return processSuggestionData('value', { canBeCompleted, token, label, parserResult })
      }

    return new Observable(observer => {
      const canBeCompleted = Boolean(nonParsed)

      codebooks
        .map(transformToSuggestion({ canBeCompleted, parserResult }))
        .filter(suggestion => suggestion)
        .forEach(suggestion => observer.next(suggestion))

      observer.complete()
    })
  } else {
    const extractTokens = () => {
      if (refsList['CODEBOOK']) {
        return ['CODEBOOK']
      }

      return []
    }

    const transformToSuggestion = ({ canBeCompleted, parserResult, suggestionTokens }) => {
      const tokens = extractTokens()
      const token = suggestionTokens.find(suggestionToken => tokens.find(token => suggestionToken === token))
      const label = 'codebook'

      return token ? processSuggestionData('codebook', { canBeCompleted, token, label, parserResult }) : null
    }

    const createSuggestions = (suggestionTokens, canBeCompleted) =>
      [transformToSuggestion({ canBeCompleted, parserResult, suggestionTokens })].filter(suggestion => suggestion)

    return new Observable(observer => {
      const isLastTokenCompletable = TOKENS_CAN_BE_COMPLETED.includes(type.last)
      const hasNonParsedText = Boolean(nonParsed)
      const hasNonParsedTextTrimmed = Boolean(nonParsed.trim())
      const canBeCompleted = Boolean(hasNonParsedTextTrimmed || (!hasNonParsedText && isLastTokenCompletable))

      const suggestedLabels = []
      const suggestionTokens =
        !hasNonParsedText && isLastTokenCompletable ? expected.prelast || expected.last || [] : expected.last || []

      createSuggestions(suggestionTokens, canBeCompleted).forEach(suggestion => {
        suggestedLabels.push(suggestion.label)
        observer.next(suggestion)
      })

      if (canBeCompleted && suggestionTokens === expected.prelast) {
        createSuggestions(expected.last || [])
          .filter(suggestion => !suggestedLabels.includes(suggestion.label))
          .forEach(suggestion => observer.next(suggestion))
      }

      observer.complete()
    })
  }
}
